export const PAGINATION_ROOM_LIST = 50;
export const PAGINATION_CALL_LIST = 50;
export const PAGINATION_CLIENT_GET_ROOM_HISTORY = 25;
